module.exports = __webpack_public_path__ + "img/pw.6faf00af.svg";